const React = require('react');
const PrintIcon = require('../../../../../icons/Print');
const BtnTableGlobal = require('../BtnTableGlobal');

module.exports = ({onClick}) => (
  <BtnTableGlobal
    icon={PrintIcon}
    text="print"
    onClick={onClick}
  />
)
